import React from "react";
import {
	SectionHeading,
	FieldsContainer,
	SettingsFormContainer,
	SaveSettingButton,
	FieldLabel,
} from "../../styles/common.styles";
import SettingsSnackbar from "../../components/SettingsSnackbar";

import TextField from "@mui/material/TextField";
import Checkbox from "@mui/material/Checkbox";
import Skeleton from "@mui/material/Skeleton";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { AlertColor } from "@mui/material/Alert";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import Autocomplete, {
	AutocompleteRenderInputParams,
} from "@mui/material/Autocomplete";

const icon = <CheckBoxOutlineBlankIcon fontSize='small' />;
const checkedIcon = <CheckBoxIcon fontSize='small' />;

interface Props {
	handleSubmit: (e: React.FormEvent<HTMLFormElement>) => void;
	settings: Record<string, string | boolean | string[]>;
	setSettings: React.Dispatch<
		React.SetStateAction<Record<string, string | boolean | string[]>>
	>;
	notice: { type: AlertColor; message: string };
	showNotice: boolean;
	setShowNotice: React.Dispatch<React.SetStateAction<boolean>>;
	loading: boolean;
}

const Permissions = ({
	handleSubmit,
	settings,
	notice,
	showNotice,
	setSettings,
	setShowNotice,
	loading,
}: Props) => {
	// @ts-ignore
	const { roles } = window.adminUiAppContext || {};

	const options = Object.keys(roles).reduce((p, c) => {
		const roleCapabilities = Object.keys(roles[c]["capabilities"]);

		if (roleCapabilities.includes("level_7")) {
			p.push(c);
		}

		return p;
	}, [] as string[]);

	return (
		<SettingsFormContainer>
			<form onSubmit={(e) => handleSubmit(e)}>
				<SettingsSnackbar
					notice={notice}
					showNotice={showNotice}
					setShowNotice={setShowNotice}
				/>

				<FieldsContainer>
					<SectionHeading variant='h6'>Permissions settings</SectionHeading>
					<FieldLabel variant='subtitle2'>
						Plugin visibility permission
						<Tooltip
							title='List of roles that can manage WooCommerce. Choose roles that can use and manage MessageFlow features.'
							placement='right'>
							<IconButton>
								<InfoOutlinedIcon fontSize='inherit' />
							</IconButton>
						</Tooltip>
					</FieldLabel>
					{settings["visibility-permission"] === undefined ||
					(settings["visibility-permission"] as string[]).length < 0 ? (
						<Skeleton variant='rectangular' width='100%'>
							<TextField />
						</Skeleton>
					) : (
						<Autocomplete
							multiple
							value={(settings["visibility-permission"] as string[]) || []}
							options={options}
							getOptionLabel={(option: any) => roles[option].name}
							style={{ width: "100%" }}
							renderInput={(params: AutocompleteRenderInputParams) => (
								<TextField
									{...params}
									name='visibility-permission'
									variant='outlined'
								/>
							)}
							getOptionDisabled={(option) => option === "administrator"}
							renderOption={(props, option, { selected }) => (
								<li {...props}>
									<Checkbox
										icon={icon}
										checkedIcon={checkedIcon}
										style={{ marginRight: 8 }}
										checked={selected}
									/>
									{roles[option].name}
								</li>
							)}
							onChange={(e, newVal: string[] | null) => {
								const includedVals = newVal;
								if (includedVals) {
									const defaultArr = [...includedVals, "administrator"];
									setSettings({
										...settings,
										"visibility-permission": defaultArr.filter(
											(item, index) => defaultArr.indexOf(item) === index,
										),
									});
								}
							}}
						/>
					)}
				</FieldsContainer>

				<SaveSettingButton
					loading={loading}
					size='large'
					variant='contained'
					type='submit'>
					Save settings
				</SaveSettingButton>
			</form>
		</SettingsFormContainer>
	);
};

export default Permissions;
